<template>
  <Layout>
    <PageHeader :title="title" />
    <section class="mc-control-tower">
      <div class="mc-control-tower__top d-flex justify-content-between mb-3">
        <div class="d-flex justify-content-start mc-control-tower__top-info">
          <div class="red-500">
            <McBadge variant="danger" size="medium" type="pill" :text="vehicleProblems"></McBadge>
            {{ $t('tower.vehicleProblems') }}
          </div>
          <div class="yellow-500">
            <McBadge
              variant="warning"
              size="medium"
              type="pill"
              :text="vehicleCompletedInspected"
            ></McBadge>
            {{ $t('tower.vehicleCompletedInspected') }}
          </div>
          <div class="teal-200">
            <McBadge variant="draft" size="medium" type="pill" :text="fleetOffline"></McBadge>
            {{ $t('tower.fleetOffline') }}
          </div>
        </div>
        <div class="mc-table-filter d-flex justify-content-end">
          <McFilterSelect
            v-if="refresh"
            :defaultColumnOrder="defaultColumnOrder"
            :currentColumnOrder="currentFields"
            :draggable="false"
            :max="4"
            @setColumn="globalSettingField"
            :loading="loading"
          />
          <b-button
            class="ms-2"
            variant="outline-primary"
            :disabled="loading"
            v-b-modal.modal-filter-ct
          >
            <i class="mc-fa icon-outline_filter"></i> {{ $t('report.object.filter') }}
          </b-button>
        </div>
      </div>
      <b-row class="mc-control-tower__list">
        <b-col md="2" v-for="(row, index) in calculatedData" :key="index">
          <div
            :class="`mc-control-tower__item mc-control-tower__item--${convertColor(
              row.controlTowerData.status
            )}`"
          >
            <h4 class="mc-control-tower__title">
              <span @click="showDetail(row)" :title="row.licensePlate">{{ row.licensePlate }}</span>

              <i
                @click="setPin(row)"
                title="Jadikan Favorit"
                :class="`mc-fa icon-${row.isPinned ? 'fill' : 'outline'}_pin_2`"
              ></i>
            </h4>
            <div
              class="mc-control-tower__info"
              v-if="
                row.controlTowerData.status === 'N' ||
                row.controlTowerData.status === 'O' ||
                row.controlTowerData.status === 'X'
              "
            >
              <ul>
                <li v-for="(placard, index) in row.placards" :key="index">
                  <template v-if="placard">
                    <span>{{ listKeys[placard].label }}</span>
                    <span>{{
                      `${
                        listKeys[placard]?.formatter && row[listKeys[placard].key]
                          ? listKeys[placard].formatter(row)
                          : row[listKeys[placard].key] === null
                          ? '-'
                          : listKeys[placard]?.formatter
                          ? listKeys[placard].formatter(row)
                          : row[listKeys[placard].key]
                      } ${listKeys[placard].addition}`
                    }}</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="mc-control-tower__info" v-else>
              <div v-if="row.controlTowerData?.alerts[0]?.alert">
                <b-button
                  :variant="`outline-${row.controlTowerData.status === 'U' ? 'danger' : 'warning'}`"
                  size="sm"
                  :title="
                    $i18n.locale === 'id'
                      ? row.controlTowerData?.alerts[0]?.alert.descriptionIdn
                      : row.controlTowerData?.alerts[0]?.alert.descriptionEng
                  "
                  >{{
                    $i18n.locale === 'id'
                      ? row.controlTowerData?.alerts[0]?.alert.descriptionIdn
                      : row.controlTowerData?.alerts[0]?.alert.descriptionEng
                  }}</b-button
                >
                <b-button
                  :variant="`outline-${row.controlTowerData.status === 'U' ? 'danger' : 'warning'}`"
                  size="sm"
                  v-if="row.controlTowerData?.alerts.length >= 2"
                  :title="
                    $i18n.locale === 'id'
                      ? row.controlTowerData?.alerts[1]?.alert.descriptionIdn
                      : row.controlTowerData?.alerts[1]?.alert.descriptionEng
                  "
                  >{{
                    $i18n.locale === 'id'
                      ? row.controlTowerData?.alerts[1]?.alert.descriptionIdn
                      : row.controlTowerData?.alerts[1]?.alert.descriptionEng
                  }}</b-button
                >
                <b-button
                  :variant="`outline-${row.controlTowerData.status === 'U' ? 'danger' : 'warning'}`"
                  size="sm"
                  v-if="row.controlTowerData?.alerts.length >= 3"
                  :title="
                    $i18n.locale === 'id'
                      ? row.controlTowerData?.alerts[2]?.alert.descriptionIdn
                      : row.controlTowerData?.alerts[2]?.alert.descriptionEng
                  "
                  >{{
                    $i18n.locale === 'id'
                      ? row.controlTowerData?.alerts[2]?.alert.descriptionIdn
                      : row.controlTowerData?.alerts[2]?.alert.descriptionEng
                  }}</b-button
                >
                <b-button
                  :variant="`outline-${row.controlTowerData.status === 'U' ? 'danger' : 'warning'}`"
                  size="sm"
                  v-if="row.controlTowerData?.alerts.length >= 4"
                  >{{ row.controlTowerData?.alerts.length - 3 }}+</b-button
                >
              </div>
              <b-button
                v-if="row.controlTowerData.status === 'U'"
                variant="primary"
                class="w-100"
                size="sm"
                @click="validate(row)"
                >{{ $t('tower.markChecked') }}</b-button
              >
              <p
                v-else-if="row.controlTowerData.status === 'R'"
                class="mc-control-tower__info-done"
              >
                <i class="mc-fa icon-outline_checkmark"></i> {{ $t('tower.checked') }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>

      <ModalSetting />
      <ModalFilter :vehicles="vehicles" @onFiltered="onFiltered" />
      <ModalDetail v-if="detail" :item="detail" @onSubmit="changePlacard" />
      <b-modal
        size="md"
        hide-header-close
        id="modal-check"
        :title="`${$t('tower.markChecked')}?`"
        centered
      >
        <p>
          {{ $t('tower.markChekedMessage') }}
          <b>{{ $t('tower.markChecked') }}</b> ?
        </p>
        <template #modal-footer>
          <div class="mc-modal__filter-footer">
            <div class="d-flex flex-row-reverse">
              <div>
                <b-button variant="outline-primary" class="me-2" @click="cancelModal()">{{
                  $t('global.cancel')
                }}</b-button>
                <b-button variant="primary" @click="markAsChecked">{{ $t('global.yes') }}</b-button>
              </div>
            </div>
          </div>
        </template>
      </b-modal>
    </section>
  </Layout>
</template>

<style lang="scss" scoped>
@import './style.scss';
</style>
<script>
import appConfig from '@/app.config'
import { mapActions } from 'vuex'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McBadge from '@/components/McBadge'
import ModalSetting from './Modal/Setting'
import McFilterSelect from '@/components/McFilterSelect'
import ModalFilter from './Modal/Filter'
import ModalDetail from './Modal/Detail'
import { GET_VEHICLE_STATUSES_CONTROL_TOWER } from '@/services/api/fleet'
import {
  CREATE_CTOWER_LOG,
  CTOWER_USER_PLACARDS,
  UPDATE_CTOWER_USER_PLACARD,
} from '@/services/api/controltower'
import responsive from '@/mixin/responsive'
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import { MixPanel } from '@/mixin/mixpanel'
import { GET_PAYLOAD } from '@/services/api/auth'
const soundNotification = require('@/assets/sounds/notification_sound.wav')

/**
 * Starter component
 */
export default {
  page: {
    title: 'Control Tower',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    McBadge,
    ModalSetting,
    ModalFilter,
    ModalDetail,
    McFilterSelect,
  },
  mixins: [responsive, Helper, MixPanel],

  data() {
    return {
      refresh: true,
      trigger: 0,
      calculatedData: [],
      vehicles: null,
      vehicleStatusesObj: null,
      detail: {},
      timeout: {},
      oldDataColumn: [],
      currentFields: [],
      loading: true,
      valDef: ['speed', 'status', 'travelTime', 'mileage'],
      lastPong: moment(),
      pongInterval: null,
      forceDisconnect: null,
      filter: {
        condition: 'all',
        vGroupId: [],
        viewOrder: null,
        licensePlate: [],
      },
    }
  },

  computed: {
    title() {
      return this.$t('menuitems.controlTower.text') + ' ' + this.$t('master.list.driver.status')
    },

    defaultColumnOrder() {
      return [
        {
          key: 'fuelPercentage',
          label: `${this.$t('liveView.infoWindow.fuel')} (%)`,
          shown: false,
        },
        {
          key: 'fuelTotal',
          label: `${this.$t('liveView.infoWindow.fuel')} (L)`,
          shown: false,
        },
        {
          key: 'mileage',
          label: `${this.$t('liveView.infoWindow.distanceTraveled')}`,
          shown: true,
        },
        {
          key: 'speed',
          label: `${this.$t('liveView.infoWindow.speed')}`,
          shown: true,
        },
        {
          key: 'engine',
          label: this.$t('global.alert.machine'),
          shown: false,
        },
        {
          key: 'refrigerator',
          label: this.$t('master.list.tracker.refrigerator'),
          shown: false,
        },
        {
          key: 'door1',
          label: this.$t('global.alert.door1'),
          shown: false,
        },
        {
          key: 'door2',
          label: this.$t('global.alert.door2'),
          shown: false,
        },
        {
          key: 'pto',
          label: 'PTO',
          shown: false,
        },
        {
          key: 'status',
          label: this.$t('global.object.fleetStatus'),
          shown: true,
        },
        {
          key: 'temp1',
          label: this.$t('liveView.infoWindow.temp1'),
          shown: false,
        },
        {
          key: 'temp2',
          label: this.$t('liveView.infoWindow.temp2'),
          shown: false,
        },
        {
          key: 'temp3',
          label: this.$t('liveView.infoWindow.temp3'),
          shown: false,
        },
        {
          key: 'travelTime',
          label: this.$t('liveView.infoWindow.elapsedTime'),
          shown: true,
        },
      ]
    },

    vehicleStatuses() {
      if (this.vehicleStatusesObj === null) return []
      let items = Object.values(this.vehicleStatusesObj)
      items.sort(function (a, b) {
        const pinnedA = a.isPinned
        const pinnedB = b.isPinned
        const countAlertA = a.controlTowerData.alerts.length
        const countAlertB = b.controlTowerData.alerts.length

        const ctStatus = ['U', 'R', 'N', 'O']
        const statusA = ctStatus.findIndex((x) => x == a.controlTowerData.status)
        const statusB = ctStatus.findIndex((x) => x == b.controlTowerData.status)
        const licensePlateA = a.licensePlate
        const licensePlateB = b.licensePlate

        if (pinnedA !== pinnedB) return pinnedA ? -1 : 1
        if (statusA !== statusB) return statusA - statusB
        if (countAlertA !== countAlertB) return countAlertB - countAlertA

        return licensePlateA.localeCompare(licensePlateB)
      })

      if (this.filter.vGroupId.length) {
        items = items.filter((x) => this.filter.vGroupId.includes(x.vehicleId))
      }

      if (this.filter.condition && this.filter.condition !== 'all') {
        items = items.filter((x) => x.controlTowerData.status == this.filter.condition)
      }

      if (this.filter.licensePlate.length) {
        items = items.filter((x) => this.filter.licensePlate.includes(x.vehicleId))
      }

      return items
    },

    listKeys() {
      return {
        fuelPercentage: {
          key: 'fuelFiltered',
          label: `${this.$t('liveView.infoWindow.fuel')} (%)`,
          addition: '%',
        },
        fuelTotal: {
          key: 'fuelCapacity',
          label: `${this.$t('liveView.infoWindow.fuel')} (L)`,
          addition: this.$t('dashboard.object.liter'),
          formatter: (row) => ((row.fuelCapacity * row.fuelFiltered) / 100).toFixed(2),
        },
        mileage: {
          key: 'sumDistance',
          label: `${this.$t('liveView.infoWindow.distanceTraveled')}`,
          addition: 'Km',
        },
        speed: {
          key: 'calculatedSpeed',
          label: `${this.$t('liveView.infoWindow.speed')}`,
          addition: `Km/${this.$t('global.time.hours')}`,
        },
        engine: {
          key: 'engineOn',
          label: this.$t('global.alert.machine'),
          addition: '',
          formatter: (row) => (row.engineOn ? 'ON' : 'OFF'),
        },
        refrigerator: {
          key: 'refrigeratorStatus',
          label: this.$t('master.list.tracker.refrigerator'),
          addition: '',
          formatter: (row) => (row.refrigeratorStatus ? 'ON' : 'OFF'),
        },
        door1: {
          key: 'door1Status',
          label: this.$t('global.alert.door1'),
          addition: '',
          formatter: (row) =>
            row.door1Status ? this.$t('global.closed') : this.$t('global.opened'),
        },
        door2: {
          key: 'door2Status',
          label: this.$t('global.alert.door2'),
          addition: '',
          formatter: (row) =>
            row.door2Status ? this.$t('global.closed') : this.$t('global.opened'),
        },
        pto: {
          key: 'ptoStatus',
          label: 'PTO',
          addition: '',
          formatter: (row) => {
            if (row.ptoStatus === null) {
              return '-'
            }

            return row.ptoStatus ? 'ON' : 'OFF'
          },
        },
        status: {
          key: 'calculatedMotionStatus',
          label: this.$t('global.object.fleetStatus'),
          addition: '',
          formatter: (row) => this.motionStatusFormat(row.calculatedMotionStatus),
        },
        temp1: {
          key: 'temperature',
          label: this.$t('liveView.infoWindow.temp1'),
          addition: '°C',
          formatter: (row) => row.temperature[0] ?? '-',
        },
        temp2: {
          key: 'temperature',
          label: this.$t('liveView.infoWindow.temp2'),
          addition: '°C',
          formatter: (row) => row.temperature[1] ?? '-',
        },
        temp3: {
          key: 'temperature',
          label: this.$t('liveView.infoWindow.temp3'),
          addition: '°C',
          formatter: (row) => row.temperature[2] ?? '-',
        },
        travelTime: {
          key: 'sumDrivetimeFormatted',
          label: this.$t('liveView.infoWindow.elapsedTime'),
          addition: '',
        },
      }
    },

    vehicleProblems() {
      if (!this.vehicleStatuses.length) {
        return null
      }

      return this.vehicleStatuses.filter((x) => x.controlTowerData.status == 'U').length.toString()
    },

    vehicleCompletedInspected() {
      if (!this.vehicleStatuses.length) {
        return null
      }

      return this.vehicleStatuses.filter((x) => x.controlTowerData.status == 'R').length.toString()
    },

    vehicleCompletedInspectedData() {
      if (!this.vehicleStatuses.length) {
        return null
      }

      return this.vehicleStatuses
        .filter((x) => x.controlTowerData.status == 'R')
        .map((x) => x.controlTowerData)
    },

    fleetOffline() {
      if (!this.vehicleStatuses.length) {
        return null
      }

      return this.vehicleStatuses
        .filter((x) => x.controlTowerData.status == 'O' || x.controlTowerData.status == 'X')
        .length.toString()
    },
  },

  watch: {
    trigger() {
      this.calculatedData = [...this.vehicleStatuses]
    },

    '$i18n.locale': function () {
      this.currentFields = []
      this.defaultColumnOrder.forEach((d) => {
        this.currentFields.push({
          ...d,
          shown:
            this.oldDataColumn !== undefined
              ? this.oldDataColumn.includes(d.key)
              : this.valDef.includes(d.key),
        })
      })
      this.refresh = false

      setTimeout(() => {
        this.refresh = true
      }, 500)
    },
  },

  async created() {
    if (this.$socket !== undefined) {
      this.$socket.close()
    }

    this.loading = true
    await this.$nextTick()
    this.getData()
    this.loading = false

    this.pongInterval = setInterval(() => {
      let diff = moment().diff(this.lastPong, 'seconds')

      // if diff > 70 second and socket ready state < 2, it means the connection is not stable, so we close the connection
      if (this.$socket !== undefined) {
        if (diff > 70 && this.$socket.readyState < 2) {
          this.$socket.close()
        }
      }
    }, 4000)
  },

  mounted() {
    if (!this.mediaQuery.matches) {
      this.$store.dispatch('layout/toggleMenu', true)
    }
  },

  beforeDestroy() {
    this.forceDisconnect = true
  },

  async destroyed() {
    await this.$store.dispatch('ws/WSDisconnect')
    clearInterval(this.pongInterval)
    this.track('Leave Control Tower Page', {
      vehicleProblems: Number(this.vehicleProblems),
      vehicleCompletedInspected: Number(this.vehicleCompletedInspected),
      fleetOffline: Number(this.fleetOffline),
    })
  },

  methods: {
    ...mapActions('announcement', [
      'incrementUnreadAnnouncement',
      'decrementUnreadAnnouncement',
      'resetUnreadAnnouncement',
      'setInitialUnreadAnnouncement',
    ]),

    async getData() {
      const { data: resVehicleStatuses } = await this.$apollo.query({
        client: 'clientLowPrio',
        query: GET_VEHICLE_STATUSES_CONTROL_TOWER,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            hasConnectedDevice: true,
          },
        },
      })

      if (resVehicleStatuses.vehicleStatuses.isSuccessful) {
        if (this.trigger === 0) this.startWebSocket()
        const vehicleStatuses = resVehicleStatuses.vehicleStatuses.vehicleStatuses
        this.vehicles = [
          ...vehicleStatuses.map((item) => {
            return { ...item.vehicle, id: item.vehicleId, licensePlate: item.licensePlate }
          }),
        ]

        const { data } = await this.$apollo.query({
          query: CTOWER_USER_PLACARDS,
          fetchPolicy: 'no-cache',
        })

        this.oldDataColumn = data.ctowerUserPlacards.ctowerUserPlacards.find(
          (x) => x.vehicleId === null
        )?.asArray

        this.vehicleStatusesObj = {}
        const now = this.now()
        vehicleStatuses.forEach((v) => {
          v.isPinned = false
          v.placards = this.valDef
          if (data.ctowerUserPlacards.ctowerUserPlacards.length) {
            const placard = data.ctowerUserPlacards.ctowerUserPlacards.find(
              (x) => x.vehicleId == v.vehicleId
            )
            if (placard !== undefined) {
              v.placards = placard.asArray
              v.isPinned = placard.isPinned
            } else {
              v.placards =
                this.oldDataColumn !== undefined ? [...this.oldDataColumn] : [...this.valDef]
            }
          }

          this.vehicleStatusesObj[v.vehicleId] = { ...v }
          if (v.controlTowerData.status === 'R') {
            const addFive = this.momentAdd(v.controlTowerData.viewedOn, 5, 'm').toISOString()
            const diff = this.calculateDate(addFive, now, 'ms')

            this.timeout[v.vehicleId] = setTimeout(() => {
              this.vehicleStatusesObj[v.vehicleId].controlTowerData.status = 'N'
              this.vehicleStatusesObj[v.vehicleId].controlTowerData.alerts.splice(
                0,
                this.vehicleStatusesObj[v.vehicleId].controlTowerData.alerts.length
              )
            }, diff)
          }
        })

        this.currentFields = []
        this.defaultColumnOrder.forEach((d) => {
          this.currentFields.push({
            ...d,
            shown:
              this.oldDataColumn !== undefined
                ? this.oldDataColumn.includes(d.key)
                : this.valDef.includes(d.key),
          })
        })

        this.loading = false
        this.track('View Control Tower Page', {
          vehicleProblems: Number(this.vehicleProblems),
          vehicleCompletedInspected: Number(this.vehicleCompletedInspected),
          fleetOffline: Number(this.fleetOffline),
        })
      }
    },

    async startWebSocket() {
      let filterByType = ['Alert', 'GPS', 'SystemNotif']
      if (this.$store.state.identity.whoami.scopes.includes('e4a-alert-center-main:read')) {
        filterByType = ['Alert', 'GPS', 'SystemNotif', 'AlertCenter']
      }
      const res = await this.$apollo.query({
        query: GET_PAYLOAD,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            filterByType,
          },
        },
      })
      const payload = res.data.getPayload.payload.payload
      const obj = {
        type: 'update_tags',
        data: payload,
      }
      await this.$store.dispatch(
        'ws/WSConnect',
        `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
      )
      this.$socket.onopen = () => {
        this.$socket.sendObj(obj)
      }

      this.$socket.onmessage = (data) => {
        const signal = JSON.parse(data.data)

        if (signal.type === 'PONG') {
          this.lastPong = moment()
          return
        }
        if (signal.hasOwnProperty('type')) {
          if (signal.type.startsWith('gps-')) {
            this.changeGpsByWs(signal.payload)
            this.changeTemperatureAlertByWs(signal.payload)
          } else if (signal.type.startsWith('alert-')) {
            if ([1, 2, 11, 14, 36, 37, 17, 18, 26].includes(signal.payload.alertCode))
              this.changeAlertByWs(signal.payload)
          }
          const userId = this.getUserId()
          if (signal.type === `system-notif-${userId}`) {
            const audio = new Audio(soundNotification)
            audio.play()
            this.$bvModal.hide('modal-notif')
            this.incrementUnreadAnnouncement()
            this.$mcToastNotif({
              component: 'McToastNotifDynamicBody',
              props: {
                payload: signal.payload,
                payloadHeader: this.$t('navbar.notif.newAnnouncement'),
                navbar: this,
              },
            })
          }
        }
      }

      this.$socket.onclose = async () => {
        if (this.forceDisconnect) return
        this.startWebSocket()
      }
    },

    checkTemperature(ra, temp) {
      return (
        (parseFloat(ra.alertData) > ra.alertTrigger && ra.alertTrigger > temp) ||
        (parseFloat(ra.alertData) < ra.alertTrigger && ra.alertTrigger < temp)
      )
    },

    changeTemperatureAlertByWs(payload) {
      if (!this.vehicleStatusesObj || this.vehicleStatusesObj[payload.vehicleId] === undefined) {
        return
      }

      const alerts = this.vehicleStatusesObj[payload.vehicleId]?.controlTowerData?.alerts ?? []
      const temp1 = alerts.findIndex((x) => x.alertCode === 18)
      if (
        temp1 >= 0 &&
        payload.temperature !== null &&
        this.checkTemperature(alerts[temp1], payload.temperature)
      )
        alerts.splice(temp1, 1)

      const temp2 = alerts.findIndex((x) => x.alertCode === 17)
      if (
        temp2 >= 0 &&
        payload.temperature2 !== null &&
        this.checkTemperature(alerts[temp2], payload.temperature2)
      )
        alerts.splice(temp2, 1)

      const temp3 = alerts.findIndex((x) => x.alertCode === 26)
      if (
        temp3 >= 0 &&
        payload.temperature3 !== null &&
        this.checkTemperature(alerts[temp3], payload.temperature3)
      )
        alerts.splice(temp3, 1)

      if (alerts.length === 0 && payload.motionStatus !== 'U' && payload.motionStatus !== 'O') {
        this.vehicleStatusesObj[payload.vehicleId].controlTowerData.status = 'N'
      } else if (
        alerts.length === 0 &&
        (payload.motionStatus === 'U' || payload.motionStatus === 'O')
      ) {
        this.vehicleStatusesObj[payload.vehicleId].controlTowerData.status = 'O'
      }
    },

    changeGpsByWs(payload) {
      if (!this.vehicleStatusesObj || this.vehicleStatusesObj[payload.vehicleId] === undefined) {
        return
      }

      const placards = [
        ...this.vehicleStatusesObj[payload.vehicleId].placards.filter((x) => x !== null),
      ]

      placards.forEach((p) => {
        let finalValue
        if (this.listKeys[p].key === 'temperature') {
          finalValue = [
            payload.temperature ?? null,
            payload.temperature2 ?? null,
            payload.temperature3 ?? null,
            payload.temperature4 ?? null,
          ]
        } else {
          finalValue = payload[this.listKeys[p].key]
        }
        this.vehicleStatusesObj[payload.vehicleId][this.listKeys[p].key] = finalValue

        if (this.detail?.vehicleId === payload.vehicleId) {
          this.detail = { ...this.detail, ...this.vehicleStatusesObj[payload.vehicleId] }
        }
      })

      this.trigger++
    },

    changeAlertByWs(payload) {
      if (!this.vehicleStatusesObj || this.vehicleStatusesObj[payload.vehicleId] === undefined) {
        return
      }

      const temp = { ...this.vehicleStatusesObj }
      if (temp[payload.vehicleId].controlTowerData.status === 'R') {
        clearTimeout(this.timeout[payload.vehicleId])
        temp[payload.vehicleId].controlTowerData.alerts.splice(
          0,
          temp[payload.vehicleId].controlTowerData.alerts.length
        )

        delete this.timeout[payload.vehicleId]
      }

      this.vehicleStatusesObj = {}
      const al = temp[payload.vehicleId].controlTowerData.alerts.findIndex(
        (x) => x.alert.alertCode == payload.alertCode
      )
      if (!temp[payload.vehicleId].controlTowerData.alerts.length || al < 0) {
        temp[payload.vehicleId].controlTowerData.status = 'U'
        temp[payload.vehicleId].controlTowerData.alerts.push({
          alert: {
            descriptionEng: payload.alertDescription.eng,
            descriptionIdn: payload.alertDescription.idn,
          },
          alertCode: payload.alertCode,
          alertData: payload.alertData,
          alertTrigger: parseFloat(payload.alertTrigger),
        })
      } else if ([17, 18, 26].includes(payload.alertCode) && al >= 0) {
        temp[payload.vehicleId].controlTowerData.alerts[al].alertData = payload.alertData
        temp[payload.vehicleId].controlTowerData.alerts[al].alertTrigger = parseFloat(
          payload.alertTrigger
        )
      }

      let priority = [11, 1, 14, 36, 2, 37, 17, 18, 26]
      temp[payload.vehicleId].controlTowerData.alerts.forEach((row) => {
        const priorityIndex = priority.findIndex((x) => x == row.alertCode)
        priority[priorityIndex] = row
      })

      priority = priority.filter((x) => typeof x != 'number')
      temp[payload.vehicleId].controlTowerData.alerts = [...priority]
      this.vehicleStatusesObj = { ...temp }
      setTimeout(() => {
        this.trigger++
      }, 100)
    },

    async changePlacard(vehicleId, placards) {
      this.vehicleStatusesObj[vehicleId].placards = placards
    },

    async showDetail(row) {
      const totalAlert = row.controlTowerData.alerts.length
      this.track('Open Control Tower Fleet Card', {
        licensePlate: row.licensePlate,
        isAlertOn: totalAlert ? true : false,
        alertName: totalAlert ? row.controlTowerData.alerts.map((x) => x.alert.descriptionEng) : [],
        alertCount: totalAlert,
      })
      this.detail = { ...row }
      await this.$nextTick()
      this.$bvModal.show('modal-detail')
    },

    async validate(row) {
      this.detail = { ...row }
      await this.$nextTick()
      this.$bvModal.show('modal-check')
    },

    markAsChecked() {
      const vehicleId = this.detail.vehicleId
      const totalAlert = this.detail.controlTowerData.alerts.length
      this.track('Control Tower Mark Checked', {
        licensePlate: this.detail.licensePlate,
        isAlertOn: totalAlert ? true : false,
        alertName: totalAlert
          ? this.detail.controlTowerData.alerts.map((x) => x.alert.descriptionEng)
          : [],
        alertCount: totalAlert,
      })
      this.$apollo
        .mutate({
          mutation: CREATE_CTOWER_LOG,
          variables: {
            input: {
              alertViewed: this.detail.controlTowerData.alerts.length,
              uncheckedVehicle: 0,
              vehicleId: vehicleId,
              viewedOn: this.now(),
            },
          },
        })
        .then(async ({ data }) => {
          if (data.createCtowerLog.isSuccessful) {
            const temp = { ...this.vehicleStatusesObj }
            this.vehicleStatusesObj = {}
            temp[vehicleId].controlTowerData.status = 'R'
            await this.$nextTick()
            this.vehicleStatusesObj = { ...temp }
            setTimeout(() => {
              this.$bvModal.hide('modal-check')
              this.trigger++
            }, 100)

            this.timeout[vehicleId] = setTimeout(() => {
              this.vehicleStatusesObj[vehicleId].controlTowerData.status = 'N'
              this.vehicleStatusesObj[vehicleId].controlTowerData.alerts.splice(
                0,
                this.vehicleStatusesObj[vehicleId].controlTowerData.alerts.length
              )
              delete this.timeout[vehicleId]
            }, 300000)
          }
        })
    },

    setPin(row) {
      this.track('Pin Control Tower Fleet Card', { licensePlate: row.licensePlate })
      this.$apollo
        .mutate({
          mutation: UPDATE_CTOWER_USER_PLACARD,
          variables: {
            input: {
              vehicleId: row.vehicleId,
              oldData: {
                isPinned: row.isPinned,
                column: this.oldDataColumn,
              },
              newData: {
                isPinned: !row.isPinned,
                column: row.placards,
              },
            },
          },
        })
        .then(async ({ data }) => {
          if (data.updateCtowerUserPlacard.isSuccessful) {
            const temp = { ...this.vehicleStatusesObj }
            this.vehicleStatusesObj = {}
            temp[row.vehicleId].isPinned = !temp[row.vehicleId].isPinned
            await this.$nextTick()
            this.vehicleStatusesObj = { ...temp }
            setTimeout(() => {
              this.trigger++
            }, 100)
          }
        })
    },

    cancelModal() {
      this.$bvModal.hide('modal-check')
    },

    convertColor(c) {
      let color = 'gray'
      switch (c) {
        case 'U':
          color = 'red'
          break
        case 'R':
          color = 'yellow'
          break
        case 'O':
          color = 'gray'
          break
        case 'N':
          color = 'green'
          break

        default:
          color = 'gray'
          break
      }

      return color
    },

    async onFiltered(form) {
      this.loading = true
      const temp = { ...this.vehicleStatusesObj }
      this.filter.condition = form.condition?.key
      this.filter.vGroupId = form.vGroup?.vehicleList
        ? [...form.vGroup.vehicleList.map((x) => x.id)]
        : []
      this.filter.viewOrder = form?.viewOrder
      this.filter.licensePlate = form?.licensePlate || []
      await this.$nextTick()
      this.vehicleStatusesObj = { ...temp }
      setTimeout(() => {
        this.trigger++
        this.loading = false
      }, 100)
    },

    globalSettingField(column) {
      this.loading = true
      const arrColumn = column.filter((x) => x.shown).map((x) => x.key)
      this.$apollo
        .mutate({
          mutation: UPDATE_CTOWER_USER_PLACARD,
          variables: {
            input: {
              oldData: {
                column: this.oldDataColumn,
              },
              newData: {
                column: arrColumn,
              },
              vehicleId: null,
            },
          },
        })
        .then(async ({ data }) => {
          if (data.updateCtowerUserPlacard.isSuccessful) {
            const temp = { ...this.vehicleStatusesObj }
            Object.keys(temp).forEach((key) => {
              temp[key].placards = arrColumn
            })
            await this.$nextTick()
            this.vehicleStatusesObj = { ...temp }
            setTimeout(() => {
              this.trigger++
              this.loading = false
            }, 100)
          }
        })
    },
  },
}
</script>
